<template>
	<div>
		<v-layout wrap>
			<!-- Main -->
			<v-flex
				:class="
					dialogAddPresentation || dialogEditPresentation || dialogAddSchedule || dialogEditSchedule || dialogAddZoomMeeting
						? 'xs6 sm6 pa-1'
						: 'xs12 sm12 pa-1'
				"
				ref="canvas"
				id="canvas"
			>
				<v-card>
					<v-tabs v-model="tab" icons-and-text>
						<v-tab @click="listPresentation()">
							Presentation List
							<v-icon>mdi-file-powerpoint-outline</v-icon>
						</v-tab>
					</v-tabs>

					<v-tabs-items v-model="tab">
						<v-tab-item>

							<v-card flat>
								<v-row class="d-flex" style="margin:10px 0px 0px 10px;">
									<v-col cols="4">
										<v-text-field class=""  label="Search" v-model="search" clearable ></v-text-field>
									</v-col>
									<v-col cols="4">
										<v-menu
											ref="searchDateMenu"
											v-model="searchDateMenu"
											:close-on-content-click="false"
											offset-y
											max-width="290px"
											min-width="auto"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													v-model="searchDate"
													clearable
													readonly
													label="Search Date"
													persistent-hint
													prepend-icon="mdi-calendar"
													v-bind="attrs"
													v-on="on"
													append-outer-icon="search" @click:append-outer="searchPresentation"
													@click:clear="date = null"
												></v-text-field>
											</template>
											<v-date-picker
												v-model="date"
												no-title
												@input="searchDateMenu = false"
												color="primary"
											></v-date-picker>
										</v-menu>
									</v-col>
									<v-col cols="4" class="text-right">
										<v-btn
											class="ma-2"
											@click.prevent="
												dialogAddPresentation = !dialogAddPresentation;
												dialogAddSchedule = false;
												dialogEditSchedule = false;
												dialogEditPresentation = false;
												dialogEditPresentation = false;
												clear();
												listPublicChatRoom();
												tabEmbedHtmlBeside = 0;
												entity.embedHtmlBesideMap.tabs = [{name: 'Tab 1', value: ''}];
												entity.embedHtmlBesideMap.resourcesTabPosition = 1;
											"
										>
											Add Presentation
											<v-icon dark>mdi-plus-thick</v-icon>
										</v-btn>
									</v-col>
								</v-row>
								<v-simple-table>
									<template v-slot:default>
										<thead>
											<tr>
												<th class="text-left">Presentation Name (Presentation Id)</th>
												<th class="text-center">Action Edit</th>
												<th class="text-center">Action Delete</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, index) in searchPresentationList" :key="index"  @drop="drop(index)" @dragover="allowDrop" >
												<td>
													<v-chip v-if=activeDrag draggable @dragstart="drag(index)">
														<v-icon >mdi-drag</v-icon>
														{{ item.title }} ({{ item.id }})
													</v-chip>
													<v-chip v-else >
														{{ item.title }} ({{ item.id }})
													</v-chip>
													<!-- Schedule -->
													<br />
													<v-btn
														v-if="item.type == typeOnDemandVideo || item.type == typePreRecordedVideo"
														class="ma-2"
														small
														text
														@click.prevent="
															dialogAddSchedule = true;
															dialogEditSchedule = false;
															dialogAddPresentation = false;
															dialogEditPresentation = false;
															clear();
															selectedPresentationId = item.id;
															listTimezone();
															listSession();
															setPosition();
														"
													>
														<v-icon dark>mdi-plus-thick</v-icon>Add Schedule
													</v-btn>
													<v-btn
														v-if="
															item.type != typeOnDemandVideo &&
															item.type != typePreRecordedVideo &&
															item.presentationScheduleList.length == 0
														"
														class="ma-2"
														small
														text
														@click.prevent="
															dialogAddSchedule = true;
															dialogEditSchedule = false;
															dialogAddPresentation = false;
															dialogEditPresentation = false;
															clear();
															selectedPresentationId = item.id;
															listTimezone();
															listSession();
															setPosition();
														"
													>
														<v-icon dark>mdi-plus-thick</v-icon>Add Schedule
													</v-btn>
													<!-- Schedule Table -->
													<v-simple-table v-if="item.presentationScheduleList.length > 0">
														<template>
															<thead>
																<tr>
																	<th class="text-center">Schedule Id</th>
																	<th class="text-center">Start Date</th>
																	<th class="text-center">End Date</th>
																	<th class="text-center">Time</th>
																	<th class="text-center">Track</th>
																	<th class="text-center">Action</th>
																</tr>
															</thead>
															<tbody>
																<tr
																	v-for="(itemPresentationSchedule, idxItemPresentationSchedule) in item.presentationScheduleList"
																	:key="idxItemPresentationSchedule"
																>
																	<td class="text-center">{{ itemPresentationSchedule.id }}</td>
																	<td class="text-center">{{ itemPresentationSchedule.dataMap.startDate }}</td>
																	<td class="text-center">{{ itemPresentationSchedule.dataMap.endDate }}</td>
																	<td class="text-center">
																		<span>
																			{{ itemPresentationSchedule.startTime }} -
																			{{ itemPresentationSchedule.endTime }}
																			<br />
																		</span>
																	</td>
																	<td class="text-center">
																		<span
																			v-for="(itemTrack, idxItemTrack) in itemPresentationSchedule.trackList"
																			:key="idxItemTrack"
																		>
																			{{ itemTrack.name }}
																			<br />
																		</span>
																	</td>
																	<td class="text-center">
																		<v-btn
																			class="ma-2"
																			text
																			small
																			@click.prevent="
																				dialogEditSchedule = true;
																				dialogAddPresentation = false;
																				dialogEditPresentation = false;
																				dialogAddSchedule = false;
																				entity = item;
																				selectedPresentationId = item.id;
																				selectedTrackId = null;
																				selectedPresentationScheduleId = itemPresentationSchedule.id;
																				startDate = itemPresentationSchedule.dataMap.startDate +
																						' ' +
																						itemPresentationSchedule.dataMap.startTime;
																				itemPresentationSchedule.dataMap.endDate != null
																					? (endDate = itemPresentationSchedule.dataMap.endDate +
																							' ' +
																							itemPresentationSchedule.dataMap.endTime
																					)
																					: (endDate = null);
																				selectedTrackList = itemPresentationSchedule.trackList;
																				trackListToTrackIdArray();
																				selectedTimezone = itemPresentationSchedule.timezone;
																				selectedSession = itemPresentationSchedule.session;
																				listTimezone();
																				listSession();
																				setPosition();
																			"
																		>
																			<v-icon dark>mdi-pencil</v-icon>
																		</v-btn>
																		<v-btn
																			class="ma-2"
																			text
																			small
																			@click.prevent="
																				dialogDeleteSchedule = true;
																				selectedPresentationScheduleId = itemPresentationSchedule.id;
																			"
																		>
																			<v-icon dark>mdi-delete</v-icon>
																		</v-btn>
																		<v-btn
																			class="ma-2"
																			v-if="
																				item.type == typeZoomMeeting &&
																				(item.hostUrl == '' ||
																					item.participantUrl == '' ||
																					item.hostUrl == null ||
																					item.participantUrl == null)
																				&& zoomSettings != null
																			"
																			text
																			small
																			@click.prevent="showAddZoomMeeting(itemPresentationSchedule, item.type);"
																		>
																			<v-icon dark>mdi-plus-thick</v-icon>Create Zoom Meeting
																		</v-btn>
																		<v-btn
																			class="ma-2"
																			v-else-if="
																				item.type == typeTeamsMeeting &&
																				(item.participantUrl == '' || item.participantUrl == null)
																			"
																			text
																			small
																			@click.prevent="createTeamsMeeting(item.id);"
																		>
																			<v-icon dark>mdi-plus-thick</v-icon>Create Teams Meeting
																		</v-btn>
																		<v-btn
																			class="ma-2"
																			v-else-if="
																				item.type == typeZoomWebinar &&
																				(item.hostUrl == '' ||
																					item.participantUrl == '' ||
																					item.hostUrl == null ||
																					item.participantUrl == null)
																				&& zoomSettings != null
																			"
																			text
																			small
																			@click.prevent="showAddZoomMeeting(itemPresentationSchedule, item.type);"
																		>
																			<v-icon dark>mdi-plus-thick</v-icon>Create Zoom Webinar
																		</v-btn>
																		<v-btn
																			class="ma-2"
																			v-else-if="
																				item.type == typeZoomMeeting &&
																				(   item.hostUrl != null ||
																					item.participantUrl != null)
																				&& zoomSettings != null
																				&& item.dataMap.zoomLinkGenerated == true
																			"
																			text
																			small
																			@click.prevent="deleteZoomLink(item.id)"
																		>
																			<v-icon dark>mdi-minus-thick</v-icon>Delete Zoom Meeting
																		</v-btn>
																		<v-btn
																			class="ma-2"
																			v-else-if="
																				item.type == typeTeamsMeeting && item.participantUrl != null
																				&& item.dataMap.teamsLinkGenerated == true
																			"
																			text
																			small
																			@click.prevent="deleteTeamsMeeting(item.id)"
																		>
																			<v-icon dark>mdi-minus-thick</v-icon>Delete Teams Meeting
																		</v-btn>
																		<v-btn
																			class="ma-2"
																			v-else-if="
																				item.type == typeZoomWebinar &&
																				(   item.hostUrl != null ||
																					item.participantUrl != null)
																				&& zoomSettings != null
																				&& item.dataMap.zoomLinkGenerated == true
																			"
																			text
																			small
																			@click.prevent="deleteZoomLink(item.id)"
																		>
																			<v-icon dark>mdi-minus-thick</v-icon>Delete Zoom Webinar
																		</v-btn>
																	</td>
																</tr>
															</tbody>
														</template>
													</v-simple-table>
													<br />
												</td>
												<td class="text-center">
													<v-btn
														class="ma-2"
														@click.prevent="
															clear();
															listPresentation();
															selectedPresentationId = item.id;
															listPresenter();
															listPublicChatRoom();
															dialogAddSchedule = false;
															dialogEditSchedule = false;
															dialogAddPresentation = false;
															entity = item;
															selectedStatus = JSON.parse(item.status);
															selectedLanguage = item.language;
															selectedType = item.type;
															selectedTopic = null;
															keyword = null;
															videoUrl = item.videoUrl;
															videoIframe = item.videoIframe;
															item.videoUrl != null ? (videoUpload = item.videoUrl) : (videoUpload = '');
															videoUrl != null && videoUrl != ''
																? videoUrl.includes('http')
																	? (selectedVideoType = videoType[0])
																	: (selectedVideoType = videoType[1])
																: (videoUrl = null);
															selectedZoomWeb = selectedZoomWeb != null ? JSON.parse(item.zoomWeb) : false;
															selectedZoomLink = selectedZoomLink != null ? JSON.parse(item.zoomLink) : false;
															selectedGroupChat = item.isOwnGroup != null ? !JSON.parse(item.isOwnGroup) : false;
															selectedUsingIframe = item.dataMap.embedCodeUsingIframe ? item.dataMap.embedCodeUsingIframe : false;
															selectedGroupChatId =
																item.groupChatId != null && !JSON.parse(item.isOwnGroup) ? item.groupChatId : null;
															selectedNoChatPresentation =
																item.dataMap.noChatPresentation != null
																	? JSON.parse(item.dataMap.noChatPresentation)
																	: false;
															showInChatLobby =
																item.dataMap.chatOnLobby != null ? JSON.parse(item.dataMap.chatOnLobby) : true;
															handoutList = item.handoutList;
															showEditPresentation(item);
															setPosition();
														"
													>
														Edit
														<v-icon dark>mdi-pencil</v-icon>
													</v-btn>
												</td>
												<td class="text-center">
													<v-btn
														class="ma-2"
														@click.prevent="
															dialogDeletePresentation = true;
															selectedPresentationId = item.id;
														"
													>
														Delete
														<v-icon dark>mdi-delete</v-icon>
													</v-btn>
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-card>
						</v-tab-item>
					</v-tabs-items>
				</v-card>
			</v-flex>

			<!-- Add Presentation -->
			<v-flex xs12 sm6 class="pa-1" v-model="dialogAddPresentation" v-if="dialogAddPresentation">
				<v-card>
					<v-card-title>
						<span class="headline">Add Presentation</span>
						<v-col class="text-right">
							<v-btn icon @click.prevent="dialogAddPresentation = false">
								<span>&#10005;</span>
							</v-btn>
						</v-col>
					</v-card-title>
					<v-card-text>
						<v-form
							ref="form"
							v-model="valid"
							@submit.prevent="savePresentation();"
						>
							<v-row>
								<v-col>
									<v-text-field v-model="entity.title" label="Title" :rules="[(v) => !!v || 'Title is required']" required></v-text-field>Description
									<editor api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="$root.initTinyMceFromVueEditor(300)" v-model="entity.description"></editor>
									<v-switch
										v-model="selectedStatus"
										:label="'Status Presentation: ' + (selectedStatus ? statusList[0] : statusList[1])"
										inset
									></v-switch>
									<v-select v-model="selectedType" :items="typeList" label="Presentation Type" :rules="[(v) => !!v || 'Presentation Type is required']" required></v-select>
									<v-switch
										v-if="selectedType == typeEmbedCode"
										v-model="selectedUsingIframe"
										:label="'Using iframe: ' + (selectedUsingIframe == true ? 'True' : 'False')"
										hint="By enabling this toogle, the code will be wrapped in an iframe"
										inset
										persistent-hint
									></v-switch>

                                    <v-switch
                                        class="mb-5"
                                        v-model="entity.toOnDemand"
                                        :label="'Change Presentation Type After End Date To On Demand Video: ' + (this.entity.toOnDemand == true ? 'True' : 'False')"
                                        hint="By enabling this toogle, the presentation type will automatically change to On DEmand Video after the end date"
                                        inset
                                        persistent-hint
                                    ></v-switch>

									<v-text-field
										v-if="selectedType && selectedType == typeZoomWebinar"
										v-model="entity.participantUrl"
										label="Zoom URL"
										required
									></v-text-field>
									<v-text-field
										v-if="selectedType && selectedType == typeZoomMeeting"
										v-model="entity.participantUrl"
										label="Zoom URL"
										required
									></v-text-field>

									<v-text-field
										v-if="selectedType == typeOnDemandVideo || selectedType == typePreRecordedVideo"
										v-model="videoUrl"
										label="URL from YouTube / Vimeo"
										hint="YouTube embed has the word embed in the URL e.g. https://www.youtube.com/embed/videoId"
										required
									></v-text-field>
									<v-text-field
										v-if="selectedType && selectedType == typeVimeoLive"
										v-model="videoIframe"
										label="Video iframe for vimeo live"
										required
									></v-text-field>
									<v-text-field
										v-if="selectedType && selectedType == typePresentationUrl"
										v-model="entity.presentationUrl"
										label="Presentation URL"
										required
									></v-text-field>
									<v-text-field
										v-if="selectedType && selectedType == typeEmbedCode"
										v-model="entity.embedCode"
										label="Embed Code"
										required
									></v-text-field>
									<v-select
										v-if="selectedType && (selectedType == typeTraining)"
										v-model="entity.dataMap.trainingCategories"
										:items="trainingCategoryList"
										item-text="categoryName"
										item-value="categoryId"
										label="Training Category"
										:rules="[(v) => !!v || 'Presentation Type is required']" multiple required>
									</v-select>

									<v-switch
										v-if="selectedType == typeZoomWebinar || selectedType == typeZoomMeeting"
										v-model="entity.dataMap.disablePreview"
										:label="'Skip The Join Meeting Screen: ' + (entity.dataMap.disablePreview == true ? 'True' : 'False')"
										inset
									></v-switch>
									<v-switch
										v-if="selectedType == typeZoomWebinar || selectedType == typeZoomMeeting"
										v-model="selectedZoomWeb"
										:label="'See Zoom Web on Platform: ' + (selectedZoomWeb == true ? 'True' : 'False')"
										inset
									></v-switch>
									<v-switch
										v-if="selectedType == typeZoomWebinar || selectedType == typeZoomMeeting"
										v-model="selectedZoomLink"
										:label="'See Zoom URL on Platform: ' + (selectedZoomLink == true ? 'True' : 'False')"
										inset
									></v-switch>
									<v-switch
										v-model="selectedNoChatPresentation"
										:label="'Turn Off Chat: ' + (selectedNoChatPresentation == true ? 'True' : 'False')"
										inset
									></v-switch>
									<v-switch
										v-if="selectedNoChatPresentation == false"
										v-model="selectedGroupChat"
										:label="'Use Existing Group Chat: ' + (selectedGroupChat == true ? 'True' : 'False')"
										inset
									></v-switch>
									<v-select
										v-if="selectedGroupChat == true && selectedNoChatPresentation == false"
										v-model="selectedGroupChatId"
										:items="publicChatRoomList"
										item-text="name"
										item-value="guid"
										label="Select Public Chat Room"
										:rules="[(v) => (!!v && /.*[^ ].*/.test(v)) || 'Please select an existing chat room']"
									></v-select>
									<v-switch
										v-if="selectedNoChatPresentation == false && selectedGroupChat == false"
										v-model="showInChatLobby"
										:label="'Show chat room in chat lobby / chat lounge: ' + (showInChatLobby == true ? 'True' : 'False')"
										inset
									></v-switch>
									<v-text-field v-model="entity.keyword" label="Keyword" required></v-text-field>
									<div style="border: 1px solid grey; border-radius: 10px" class="pa-4">
										<v-combobox
											v-model="entity.embedHtmlBesideMap.status"
											:items="itemEmbedHtmlBeside"
											label="Embed Html Beside"
										></v-combobox>
										<v-text-field
											v-model="entity.dataMap.heightEmbedHtmlBeside"
											label="Height Embed Html Beside"
											type="number"
										></v-text-field>
										<template v-if="entity.embedHtmlBesideMap.tabs" >
											<v-tabs v-model="tabEmbedHtmlBeside" >
												<v-tab
													class="pa-0"
													v-for="(tab, index) in entity.embedHtmlBesideMap.tabs" :key="index"
													:disabled="entity.embedHtmlBesideMap.status == 'None'"
												>
													<span v-if="tabEmbedHtmlBeside !== index" class="mr-4 ml-2" style="text-transform: none;">{{tab.name}}</span>
													<v-text-field
														v-else
														filled
														v-model="tab.name"
														class="mb-1"
														hide-details="auto"
														style="width:auto; background: white"
													></v-text-field>
													<v-btn
														v-if="entity.embedHtmlBesideMap.tabs.length !== 1 && entity.embedHtmlBesideMap.status !== 'None' && tabEmbedHtmlBeside !== index"
														class="pa-0 ma-0"
														fab
														x-small
														style="width: 15px; height: 15px"
														@click="removeTab(index)"
														elevation="0"
													>
														<span style="color:black">X</span>
													</v-btn>
												</v-tab>
												<v-btn
													v-if="entity.embedHtmlBesideMap.tabs && entity.embedHtmlBesideMap.tabs.length < 3 && entity.embedHtmlBesideMap.status !== 'None'"
													class="mt-2 ml-2"
													fab dark
													color="primary"
													x-small
													@click="newTab()"
												>
													<v-icon color="white">
														mdi-plus
													</v-icon>
												</v-btn>
											</v-tabs>
											<v-tabs-items v-model="tabEmbedHtmlBeside">
												<v-tab-item v-for="(tab, index) in entity.embedHtmlBesideMap.tabs" :key="index" >
													<v-switch
														v-model="tab.isUsingIframe"
														class="pa-2 mb-5"
														:label="'Using iframe: ' + (!tab.isUsingIframe && tab.isUsingIframe == true ? 'True' : 'False')"
														hint="By enabling this toogle, the code will be wrapped in an iframe"
														inset
														persistent-hint
													></v-switch>
													<v-textarea v-model="tab.value" label="Embed Html" :disabled="entity.embedHtmlBesideMap.status == 'None'" dense></v-textarea>
												</v-tab-item>
											</v-tabs-items>
										</template>
										<v-text-field
											v-if="entity.embedHtmlBesideMap.status != 'None'"
											v-model="entity.embedHtmlBesideMap.resourcesTabPosition"
											label="Resources Tab Position"
											type="number"
											min=1
											max=4
										></v-text-field>

									</div>

									<div style="border: 1px solid grey; border-radius: 10px" class="pa-4 mt-4">
										<v-text-field
											v-model="entity.dataMap.heightEmbedHtmlBelow"
											label="Height Embed Html Below"
											type="number"
										></v-text-field>
										<v-textarea v-model="entity.embedHtmlBelow" label="Embed HTML Below" dense></v-textarea>
										</div>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12">
									<v-select
										v-model="entity.allowTicketList"
										:items="ticketList"
										item-text="name"
										item-value="id"
										label="Allowed Ticket List"
										multiple
										chips
										hint="Empty list means all access"
										persistent-hint
									></v-select>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12">
									<v-select
										v-model="entity.denyTicketList"
										:items="ticketList"
										item-text="name"
										item-value="id"
										label="Denied Ticket List"
										multiple
										chips
									></v-select>
								</v-col>
							</v-row>

							<div class="d-flex justify-end">
								<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
							</div>
						</v-form>
					</v-card-text>
				</v-card>
			</v-flex>

			<!-- Add Schedule-->
			<v-flex xs12 sm6 class="pa-1" v-model="dialogAddSchedule" v-if="dialogAddSchedule" v-bind:style="{ marginTop: marginTop + 'px'}">
				<v-card>
					<v-card-title>
						<span class="headline">Add Schedule</span>
						<v-col class="text-right">
							<v-btn icon @click.prevent="dialogAddSchedule = false">
								<span>&#10005;</span>
							</v-btn>
						</v-col>
					</v-card-title>
					<v-card-text>
						<v-form
							ref="form"
							v-model="valid"
							@submit.prevent="
								savePresentationSchedule();
							"
						>
							<v-row>
								<v-col>
									<template>
										<v-menu
											ref="startDateMenu"
											v-model="isShowStartDate"
											:close-on-content-click="false"
											:return-value.sync="startDate"
											:nudge-right="40"
											transition="scale-transition"
											offset-y
											min-width="290px"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													autocapitalize
													label="Start Date"
													append-icon="mdi-calendar"
													:value="formatDate(startDate)"
													readonly
													v-on="on"
													v-bind="attrs"
													autocomplete="off"
													@click="resetTime"
												></v-text-field>
											</template>
											<v-date-picker
												:min="new Date().toISOString().substr(0, 10)"
												v-model="startDate"
												@input="startDate = changeDatetime(startDate)"
												color="primary"
												no-title
											>
												<div class="d-flex flex-column" style="width: 100%">
													<div class="d-flex flex-row align-space-arround">
														<span>Time</span>
														<v-select
															v-model="hour"
															:items="
																Array(24)
																	.fill()
																	.map((x, i) => ('' + i).padStart(2, '0'))
															"
															class="mx-2"
															style="width: 10px"
															dense
															append-icon="false"
															@input="startDate = changeDatetime(startDate)"
														>
															<template
																v-slot:selection="{
																	item,
																}"
															>
																<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{
																	item
																}}</span>
															</template> </v-select
														>:
														<v-select
															v-model="minute"
															:items="
																Array(60)
																	.fill()
																	.map((x, i) => ('' + i).padStart(2, '0'))
															"
															class="mx-2"
															style="width: 10px"
															dense
															append-icon="false"
															@input="startDate = changeDatetime(startDate)"
														>
															<template
																v-slot:selection="{
																	item,
																}"
															>
																<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{
																	item
																}}</span>
															</template>
														</v-select>
													</div>
													<v-divider></v-divider>
													<div class="d-flex justify-end">
														<v-btn text color="primary" @click="isShowStartDate = false">Cancel</v-btn>
														<v-btn
															text
															color="primary"
															@click="$refs.startDateMenu.save((startDate = changeDatetime(startDate)))"
															>OK</v-btn
														>
													</div>
												</div>
											</v-date-picker>
										</v-menu>
										<v-menu
											ref="endDateMenu"
											v-model="isShowEndDate"
											:close-on-content-click="false"
											:return-value.sync="endDate"
											:nudge-right="40"
											transition="scale-transition"
											offset-y
											min-width="290px"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													autocapitalize
													label="End Date"
													append-icon="mdi-calendar"
													:value="formatDate(endDate)"
													readonly
													v-on="on"
													v-bind="attrs"
													autocomplete="off"
													@click="resetTime"
												></v-text-field>
											</template>
											<v-date-picker
												:min="new Date().toISOString().substr(0, 10)"
												v-model="endDate"
												@input="endDate = changeDatetime(endDate)"
												color="primary"
												no-title
											>
												<div class="d-flex flex-column" style="width: 100%">
													<div class="d-flex flex-row align-space-arround">
														<span>Time</span>
														<v-select
															v-model="hour"
															:items="
																Array(24)
																	.fill()
																	.map((x, i) => ('' + i).padStart(2, '0'))
															"
															class="mx-2"
															style="width: 10px"
															dense
															append-icon="false"
															@input="endDate = changeDatetime(endDate)"
														>
															<template
																v-slot:selection="{
																	item,
																}"
															>
																<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{
																	item
																}}</span>
															</template> </v-select
														>:
														<v-select
															v-model="minute"
															:items="
																Array(60)
																	.fill()
																	.map((x, i) => ('' + i).padStart(2, '0'))
															"
															class="mx-2"
															style="width: 10px"
															dense
															append-icon="false"
															@input="endDate = changeDatetime(endDate)"
														>
															<template
																v-slot:selection="{
																	item,
																}"
															>
																<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{
																	item
																}}</span>
															</template>
														</v-select>
													</div>
													<v-divider></v-divider>
													<div class="d-flex justify-end">
														<v-btn text color="primary" @click="isShowEndDate = false">Cancel</v-btn>
														<v-btn
															text
															color="primary"
															@click="$refs.endDateMenu.save((endDate = changeDatetime(endDate)))"
															>OK</v-btn
														>
													</div>
												</div>
											</v-date-picker>
										</v-menu>
										<v-autocomplete
											v-model="selectedTimezone"
											:items="timezoneList"
											:loading="isLoading"
											hide-selected
											label="Timezone"
											required
										></v-autocomplete>
										<v-combobox
											v-model="selectedSession"
											:items="sessionList"
											label="Session"
											hint="Pick from list or start typing a new session name"
											persistent-hint
											required
										></v-combobox>

										<!-- Selected Track -->
										<br />
										<span>Selected Track:</span>
										<br />
										<div v-for="(item, idxItem) in trackList" :key="idxItem">
											<div v-for="(itemSelectedTrack, idxItemSelectedTrack) in selectedTrackIdArray" :key="idxItemSelectedTrack">
												<span v-if="item.id == itemSelectedTrack">
													{{ item.name }}
													<v-btn icon @click.prevent="removeTrackId(itemSelectedTrack)">
														<span>&#10005;</span>
													</v-btn>
												</span>
											</div>
										</div>
										<v-select
											item-text="name"
											item-value="id"
											v-model="selectedTrackId"
											:items="trackList"
											label="Track"
											required
										></v-select>
										<v-btn @click.prevent="pushTrackId(selectedTrackId)">Add Track</v-btn>
									</template>
								</v-col>
							</v-row>

							<div class="d-flex justify-end">
								<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
							</div>
						</v-form>
					</v-card-text>
				</v-card>
			</v-flex>

			<!-- Add Zoom Meeting -->
			<v-flex xs12 sm6 class="pa-1" v-model="dialogAddZoomMeeting" v-if="dialogAddZoomMeeting" v-bind:style="{ marginTop: marginTop + 'px'}">
				<v-card>
					<v-card-title>
						<span class="headline">Create Zoom{{selectedPresentationType == typeZoomWebinar ? ' Webinar' : ' Meeting'}}</span>
						<v-col class="text-right">
							<v-btn icon @click.prevent="dialogAddZoomMeeting = false; clearZoomGenerateForm();">
								<span>&#10005;</span>
							</v-btn>
						</v-col>
					</v-card-title>
					<v-card-text>
						<v-form
							ref="form"
							v-model="valid"
							@submit.prevent="
								selectedPresentationType == typeZoomWebinar ? createZoomWebinar() : createZoomMeeting();
								dialogAddZoomMeeting = false;
							"
						>
							<v-row>
								<v-col>
									<v-text-field v-model="entityZoomMeeting.topic" label="Topic" required></v-text-field>
									<v-text-field v-model="entityZoomMeeting.agenda" label="Meeting Agenda" required></v-text-field>
									<v-text-field v-model="entityZoomMeeting.password" label="Meeting Passcode" required></v-text-field>
									<v-select v-model="selectedTimezone" :items="timezoneList" label="Timezone" required></v-select>
								</v-col>
							</v-row>

							<div class="d-flex justify-end">
								<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
							</div>
						</v-form>
					</v-card-text>
				</v-card>
			</v-flex>

			<!-- Edit Presentation -->
			<v-flex xs12 sm6 class="pa-1" v-model="dialogEditPresentation" v-if="dialogEditPresentation"  v-bind:style="{ marginTop: marginTop + 'px'}">
				<v-card>
					<v-form
						ref="form"
						v-model="valid"
						@submit.prevent="
							editPresentation(selectedPresentationId);
						"
					>
						<v-card-title>
							<span class="headline">Edit Presentation</span>
							<v-col class="text-right">
								<v-btn icon @click.prevent="dialogEditPresentation = false">
									<span>&#10005;</span>
								</v-btn>
							</v-col>
						</v-card-title>
						<v-card-text>
							<v-container>
								<v-row>
									<v-col>
										<div>
											Selected Presenter:
											<br />
											<span v-for="(person, idxPerson) in selectedPersonArray" :key="idxPerson">
												{{ person.email }} - {{ person.firstName }} {{ person.lastName }}, {{ person.title }}
												<span v-if="person.dataMap.topic != null">- {{ person.dataMap.topic }}</span>
												<v-btn icon @click.prevent="removePresenter(person.id)">
													<span>&#10005;</span>
												</v-btn>
												<br />
											</span>
										</div>

										<v-textarea
											v-model="keyword"
											label="Input presenter email list (separated by new line)"
											required
										></v-textarea>
										<v-text-field v-model="selectedTopic" label="Presenter Topic" required></v-text-field>
										<v-btn text @click.prevent="addPresenter(keyword)">Add Presenter</v-btn>
										<br />
										<br />
										<div>
											Uploaded Handout:
											<br />
											<span v-for="(handout, idxHandout) in handoutList" :key="idxHandout">
												{{ handout.title }}
												<v-btn icon @click.prevent="removeHandout(handout.id)">
													<span>&#10005;</span>
												</v-btn>
												<br />
											</span>
										</div>
										<br />
										<span>Handout</span>
										<v-file-input
											accept="application/pdf, text/plain, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, .rar, image/jpg, image/jpeg, image/png, video/mp4"
											@change="handleFile1Upload"
											show-size
											counter
											multiple
											:label="'Handout 1'"
										></v-file-input>
										<v-file-input
											accept="application/pdf, text/plain, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, .rar, image/jpg, image/jpeg, image/png, video/mp4"
											@change="handleFile2Upload"
											show-size
											counter
											multiple
											:label="'Handout 2'"
										></v-file-input>
										<v-file-input
											accept="application/pdf, text/plain, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, .rar, image/jpg, image/jpeg, image/png, video/mp4"
											@change="handleFile3Upload"
											show-size
											counter
											multiple
											:label="'Handout 3'"
										></v-file-input>
										<v-file-input
											accept="application/pdf, text/plain, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, .rar, image/jpg, image/jpeg, image/png, video/mp4"
											@change="handleFile4Upload"
											show-size
											counter
											multiple
											:label="'Handout 4'"
										></v-file-input>
										<v-file-input
											accept="application/pdf, text/plain, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, .rar, image/jpg, image/jpeg, image/png, video/mp4"
											@change="handleFile5Upload"
											show-size
											counter
											multiple
											:label="'Handout 5'"
										></v-file-input>
										<v-text-field v-model="entity.title" label="Title" :rules="[(v) => !!v || 'Title is required']" required></v-text-field>Description
										<editor api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="$root.initTinyMceFromVueEditor(300)" v-model="entity.description"></editor>
										<v-switch
											v-model="selectedStatus"
											:label="'Status Presentation: ' + (selectedStatus ? statusList[0] : statusList[1])"
											inset
										></v-switch>
										<v-select v-model="selectedType" :items="typeList" label="Presentation Type" :rules="[(v) => !!v || 'Presentation Type is required']" required></v-select>
										<template v-if="selectedType == typeOnDemandVideo || selectedType == typePreRecordedVideo">
											<v-text-field
												v-model="videoUrl"
												:label="videoUrl ? videoUrl : 'URL from YouTube / Vimeo'"
												hint="YouTube embed has the word embed in the URL e.g. https://www.youtube.com/embed/videoId"
												required
											></v-text-field>
											<br />Preview Your URL
											<v-container>
												<iframe
													frameborder="0"
													allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
													scrolling="0"
													width="450"
													height="240"
													:src="
														videoUrl != null
															? videoUrl.includes('http')
																? videoUrl
																: baseLocation + '/asset/file/' + videoUpload
															: null
													"
													allowfullscreen
												></iframe>
											</v-container>
										</template>

                                        <v-switch
											class="mb-5"
											v-model="entity.toOnDemand"
											:label="'Change Presentation Type After End Date To On Demand Video: ' + (entity.toOnDemand == true ? 'True' : 'False')"
											hint="By enabling this toogle, the presentation type will automatically change to On DEmand Video after the end date"
											inset
											persistent-hint
										></v-switch>

										<v-switch
											class="mb-5"
											v-if="selectedType == typeEmbedCode"
											v-model="selectedUsingIframe"
											:label="'Using iframe: ' + (selectedUsingIframe == true ? 'True' : 'False')"
											hint="By enabling this toogle, the code will be wrapped in an iframe"
											inset
											persistent-hint
										></v-switch>
										<v-text-field
											v-if="selectedType && (selectedType == typeZoomWebinar || selectedType == typeZoomMeeting)"
											v-model="entity.participantUrl"
											label="Zoom URL"
											required
										></v-text-field>
										<v-text-field
											v-if="selectedType && selectedType == typeTeamsMeeting"
											v-model="entity.participantUrl"
											label="Teams URL"
											required
										></v-text-field>
										<v-text-field
											v-if="selectedType && selectedType == typeVimeoLive"
											v-model="videoIframe"
											label="Video iframe for vimeo live"
											required
										></v-text-field>
										<v-text-field
											v-if="selectedType && (selectedType == typePresentationUrl)"
											v-model="entity.presentationUrl"
											label="Presentation URL"
											required
										></v-text-field>
										<v-text-field
											v-if="selectedType && (selectedType == typeEmbedCode)"
											v-model="entity.embedCode"
											label="Embed Code"
											required
										></v-text-field>
										<v-select
											v-if="selectedType && (selectedType == typeTraining)"
											v-model="entity.dataMap.trainingCategories"
											:items="trainingCategoryList"
											item-text="categoryName"
											item-value="categoryId"
											label="Training Category"
											:rules="[(v) => !!v || 'Presentation Type is required']" multiple required>
										</v-select>


										<v-switch
											v-if="selectedType == typeZoomWebinar || selectedType == typeZoomMeeting"
											v-model="entity.dataMap.disablePreview"
											:label="'Skip The Join Meeting Screen: ' + (entity.dataMap.disablePreview == true ? 'True' : 'False')"
											inset
										></v-switch>
										<v-switch
											v-if="selectedType == typeZoomWebinar || selectedType == typeZoomMeeting"
											v-model="selectedZoomWeb"
											:label="'See Zoom Web on Platform: ' + (selectedZoomWeb == true ? 'True' : 'False')"
											inset
										></v-switch>
										<v-switch
											v-if="selectedType == typeZoomWebinar || selectedType == typeZoomMeeting"
											v-model="selectedZoomLink"
											:label="
												'See Zoom URL on Platform: ' + (selectedZoomLink == true ? 'True' : 'False')
											"
											inset
										></v-switch>
										<v-switch
											v-model="selectedNoChatPresentation"
											:label="'Turn Off Chat: ' + (selectedNoChatPresentation == true ? 'True' : 'False')"
											inset
										></v-switch>
										<v-switch
											v-if="selectedNoChatPresentation == false"
											v-model="selectedGroupChat"
											:label="'Use Existing Group Chat: ' + (selectedGroupChat == true ? 'True' : 'False')"
											inset
										></v-switch>
										<v-select
											v-if="selectedGroupChat == true && selectedNoChatPresentation == false"
											v-model="selectedGroupChatId"
											:items="publicChatRoomList"
											item-text="name"
											item-value="guid"
											label="Select Public Chat Room"
											:rules="[(v) => (!!v && /.*[^ ].*/.test(v)) || 'Please select an existing chat room']"
										></v-select>
										<v-switch
											v-if="selectedNoChatPresentation == false && selectedGroupChat == false"
											v-model="showInChatLobby"
											:label="'Show chat room in chat lobby / chat lounge: ' + (showInChatLobby == true ? 'True' : 'False')"
											inset
										></v-switch>
										<v-text-field v-model="entity.keyword" label="Keyword" required></v-text-field>
										<div style="border: 1px solid grey; border-radius: 10px" class="pa-4">
											<v-combobox
												v-model="entity.embedHtmlBesideMap.status"
												:items="itemEmbedHtmlBeside"
												label="Embed Html Beside"
											></v-combobox>
											<v-text-field
												v-model="entity.dataMap.heightEmbedHtmlBeside"
												label="Height Embed Html Beside"
												type="number"
											></v-text-field>
											<template v-if="entity.embedHtmlBesideMap.tabs">
												<v-tabs v-model="tabEmbedHtmlBeside" >
													<v-tab
														class="pa-0"
														v-for="(tab, index) in entity.embedHtmlBesideMap.tabs" :key="index"
														:disabled="entity.embedHtmlBesideMap.status == 'None'"
													>
														<span v-if="tabEmbedHtmlBeside !== index" class="mr-4 ml-2" style="text-transform: none;">{{tab.name}}</span>
														<v-text-field
															v-else
															filled
															v-model="tab.name"
															class="mb-1"
															hide-details="auto"
															style="width:auto; background: white"
														></v-text-field>
														<v-btn
															v-if="entity.embedHtmlBesideMap.tabs.length !== 1 && entity.embedHtmlBesideMap.status !== 'None' && tabEmbedHtmlBeside !== index"
															class="pa-0 ma-0"
															fab
															x-small
															style="width: 15px; height: 15px"
															@click="removeTab(index)"
															elevation="0"
														>
															<span style="color:black">X</span>
														</v-btn>
													</v-tab>
													<v-btn
														v-if="entity.embedHtmlBesideMap.tabs.length < 3 && entity.embedHtmlBesideMap.status !== 'None'"
														class="mt-2 ml-2"
														fab dark
														color="primary"
														x-small
														@click="newTab()"
													>
														<v-icon color="white">
															mdi-plus
														</v-icon>
													</v-btn>
												</v-tabs>
												<v-tabs-items v-model="tabEmbedHtmlBeside">
													<v-tab-item v-for="(tab, index) in entity.embedHtmlBesideMap.tabs" :key="index" >
														<v-switch
															v-model="tab.isUsingIframe"
															class="pa-2 mb-5"
															:label="'Using iframe: ' + (!tab.isUsingIframe && tab.isUsingIframe == true ? 'True' : 'False')"
															hint="By enabling this toogle, the code will be wrapped in an iframe"
															inset
															persistent-hint
														></v-switch>
														<v-textarea v-model="tab.value" label="Embed Html" :disabled="entity.embedHtmlBesideMap.status == 'None'" dense></v-textarea>
													</v-tab-item>
												</v-tabs-items>
											</template>
											<v-text-field
												v-if="entity.embedHtmlBesideMap.status != 'None'"
												v-model="entity.embedHtmlBesideMap.resourcesTabPosition"
												label="Resources Tab Position"
												type="number"
												min=1
												max=4
											></v-text-field>
										</div>

										<div style="border: 1px solid grey; border-radius: 10px" class="pa-4 mt-4">
											<v-text-field
												v-model="entity.dataMap.heightEmbedHtmlBelow"
												label="Height Embed Html Below"
												type="number"
											></v-text-field>
											<v-textarea v-model="entity.embedHtmlBelow" label="Embed HTML Below" dense></v-textarea>
										</div>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<v-select
											v-model="entity.allowTicketList"
											:items="ticketList"
											item-text="name"
											item-value="id"
											label="Allowed Ticket List"
											multiple
											chips
											hint="Empty list means all access"
											persistent-hint
										></v-select>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<v-select
											v-model="entity.denyTicketList"
											:items="ticketList"
											item-text="name"
											item-value="id"
											label="Denied Ticket List"
											multiple
											chips
										></v-select>
									</v-col>
								</v-row>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="blue darken-1" text @click.prevent="dialogEditPresentation = false">Close</v-btn>
							<v-btn :disabled="!valid" type="submit" color="blue darken-1" text>Save</v-btn>
						</v-card-actions>
					</v-form>
				</v-card>
			</v-flex>

			<!-- Edit Schedule -->
			<v-flex xs12 sm6 class="pa-1" v-model="dialogEditSchedule" v-if="dialogEditSchedule" v-bind:style="{ marginTop: marginTop + 'px'}">
				<v-card>
					<v-card-title>
						<span class="headline">Edit Schedule</span>
						<v-col class="text-right">
							<v-btn icon @click.prevent="dialogEditSchedule = false">
								<span>&#10005;</span>
							</v-btn>
						</v-col>
					</v-card-title>
					<v-card-text>
						<v-container>
							<v-row>
								<v-col>
									<template>
										<v-menu
											ref="startDateMenu"
											v-model="isShowStartDate"
											:close-on-content-click="false"
											:return-value.sync="startDate"
											:nudge-right="40"
											transition="scale-transition"
											offset-y
											min-width="290px"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													autocapitalize
													label="Start Date"
													append-icon="mdi-calendar"
													:value="formatDate(startDate)"
													readonly
													v-on="on"
													v-bind="attrs"
													autocomplete="off"
													@click="resetTime"
												></v-text-field>
											</template>
											<v-date-picker
												:min="new Date().toISOString().substr(0, 10)"
												v-model="startDate"
												@input="startDate = changeDatetime(startDate)"
												color="primary"
												no-title
											>
												<div class="d-flex flex-column" style="width: 100%">
													<div class="d-flex flex-row align-space-arround">
														<span>Time</span>
														<v-select
															v-model="hour"
															:items="
																Array(24)
																	.fill()
																	.map((x, i) => ('' + i).padStart(2, '0'))
															"
															class="mx-2"
															style="width: 10px"
															dense
															append-icon="false"
															@input="startDate = changeDatetime(startDate)"
														>
															<template
																v-slot:selection="{
																	item,
																}"
															>
																<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{
																	item
																}}</span>
															</template> </v-select
														>:
														<v-select
															v-model="minute"
															:items="
																Array(60)
																	.fill()
																	.map((x, i) => ('' + i).padStart(2, '0'))
															"
															class="mx-2"
															style="width: 10px"
															dense
															append-icon="false"
															@input="startDate = changeDatetime(startDate)"
														>
															<template
																v-slot:selection="{
																	item,
																}"
															>
																<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{
																	item
																}}</span>
															</template>
														</v-select>
													</div>
													<v-divider></v-divider>
													<div class="d-flex justify-end">
														<v-btn text color="primary" @click="isShowStartDate = false">Cancel</v-btn>
														<v-btn
															text
															color="primary"
															@click="$refs.startDateMenu.save((startDate = changeDatetime(startDate)))"
															>OK</v-btn
														>
													</div>
												</div>
											</v-date-picker>
										</v-menu>
										<v-menu
											ref="endDateMenu"
											v-model="isShowEndDate"
											:close-on-content-click="false"
											:return-value.sync="endDate"
											:nudge-right="40"
											transition="scale-transition"
											offset-y
											min-width="290px"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													autocapitalize
													label="End Date"
													append-icon="mdi-calendar"
													:value="formatDate(endDate)"
													readonly
													v-on="on"
													v-bind="attrs"
													autocomplete="off"
													@click="resetTime"
												></v-text-field>
											</template>
											<v-date-picker
												:min="new Date().toISOString().substr(0, 10)"
												v-model="endDate"
												@input="endDate = changeDatetime(endDate)"
												color="primary"
												no-title
											>
												<div class="d-flex flex-column" style="width: 100%">
													<div class="d-flex flex-row align-space-arround">
														<span>Time</span>
														<v-select
															v-model="hour"
															:items="
																Array(24)
																	.fill()
																	.map((x, i) => ('' + i).padStart(2, '0'))
															"
															class="mx-2"
															style="width: 10px"
															dense
															append-icon="false"
															@input="endDate = changeDatetime(endDate)"
														>
															<template
																v-slot:selection="{
																	item,
																}"
															>
																<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{
																	item
																}}</span>
															</template> </v-select
														>:
														<v-select
															v-model="minute"
															:items="
																Array(60)
																	.fill()
																	.map((x, i) => ('' + i).padStart(2, '0'))
															"
															class="mx-2"
															style="width: 10px"
															dense
															append-icon="false"
															@input="endDate = changeDatetime(endDate)"
														>
															<template
																v-slot:selection="{
																	item,
																}"
															>
																<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{
																	item
																}}</span>
															</template>
														</v-select>
													</div>
													<v-divider></v-divider>
													<div class="d-flex justify-end">
														<v-btn text color="primary" @click="isShowEndDate = false">Cancel</v-btn>
														<v-btn
															text
															color="primary"
															@click="$refs.endDateMenu.save((endDate = changeDatetime(endDate)))"
															>OK</v-btn
														>
													</div>
												</div>
											</v-date-picker>
										</v-menu>
										<v-autocomplete
											v-model="selectedTimezone"
											:items="timezoneList"
											:loading="isLoading"
											hide-selected
											label="Timezone"
											required
										></v-autocomplete>
										<v-combobox
											v-model="selectedSession"
											:items="sessionList"
											label="Session"
											hint="Pick from list or start typing a new session name"
											persistent-hint
											required
										></v-combobox>

										<!-- Selected Track -->
										<br />
										<span>Selected Track:</span>
										<br />
										<div v-for="(item, idxItem) in trackList" :key="idxItem">
											<div v-for="(itemSelectedTrack, idxItemSelectedTrack) in selectedTrackIdArray" :key="idxItemSelectedTrack">
												<span v-if="item.id == itemSelectedTrack">
													{{ item.name }}
													<v-btn icon @click.prevent="removeTrackId(itemSelectedTrack)">
														<span>&#10005;</span>
													</v-btn>
												</span>
											</div>
										</div>
										<v-select
											item-text="name"
											item-value="id"
											v-model="selectedTrackId"
											:items="trackList"
											label="Track"
											required
										></v-select>
										<v-btn @click.prevent="pushTrackId(selectedTrackId)">Add Track</v-btn>
									</template>
								</v-col>
							</v-row>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" text @click.prevent="dialogEditSchedule = false">Close</v-btn>
						<v-btn
							color="blue darken-1"
							text
							@click.prevent="
								editPresentationSchedule(selectedPresentationScheduleId);
							"
							>Save</v-btn
						>
					</v-card-actions>
				</v-card>
			</v-flex>
		</v-layout>

		<!-- Delete -->
		<v-dialog v-model="dialogDeletePresentation" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Delete Presentation</span>
				</v-card-title>
				<v-card-text>Are you sure to delete this presentation ?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click.prevent="dialogDeletePresentation = false">Cancel</v-btn>
					<v-btn
						color="blue darken-1"
						text
						@click.prevent="
							dialogDeletePresentation = false;
							deletePresentation(selectedPresentationId);
						"
						>Delete</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Delete Schedule -->
		<v-dialog v-model="dialogDeleteSchedule" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Delete Schedule</span>
				</v-card-title>
				<v-card-text>Are you sure to delete this schedule ?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click.prevent="dialogDeleteSchedule = false">Cancel</v-btn>
					<v-btn
						color="blue darken-1"
						text
						@click.prevent="
							dialogDeleteSchedule = false;
							deletePresentationSchedule(selectedPresentationScheduleId);
						"
						>Delete</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<style scoped>
.v-chip {
	background: white !important;
	border-radius:10px !important;
}
</style>
<script>
import axios from "axios";
import moment from "moment";
import Editor from "@tinymce/tinymce-vue";

export default {
	props: ["experienceId"],
	components: {
		editor: Editor
	},
	data() {
		return {
			valid: true,
			tab: null,
			entity: {
				title: null,
				description: null,
				status: null,
				language: null,
				keyword: null,
				type: null,
				videoUrl: null,
				videoIframe: null,
				participantUrl: null,
				presentationUrl: null,
				embedCode: null,
				dataMap: {},
				embedHtmlBesideMap:{ status: "None", value: "", tabs: {}, resourcesTabPosition: 1 },
                toOnDemand: null,
			},
			entityZoomMeeting: {
				topic: null,
				timezone: null,
				password: null,
				agenda: null,
			},
			presentationList: null,
			presentationScheduleList: null,
			trackList: null,
			statusList: ["Active", "Inactive"],
			languageList: ["English", "Arabic", "Chinese", "French", "German", "Japanese", "Italian", "Korea", "Other"],
			timezoneList: [],
			createFromPlatformList: ["Zoom portal", "This platform"],
			personList: null,
			typeList: ["On-Demand Video", "Pre-recorded Video", "Zoom Webinar", "Zoom Meeting", "Vimeo Live", "Presentation URL", "Embed Code", "Teams Meeting", "Training"],
			typeOnDemandVideo: "On-Demand Video",
			typePreRecordedVideo: "Pre-recorded Video",
			typeZoomWebinar: "Zoom Webinar",
			typeZoomMeeting: "Zoom Meeting",
			typeTeamsMeeting: "Teams Meeting",
			typeVimeoLive: "Vimeo Live",
			typePresentationUrl: "Presentation URL",
			typeEmbedCode: "Embed Code",
			typeTraining: "Training",
			videoType: ["Video URL", "Video Upload"],
			publicChatRoomList: [],
			handoutList: null,
			sessionList: null,
			selectedStatus: true,
			selectedLanguage: null,
			selectedType: null,
			selectedPresentationId: null,
			selectedPresentationType: null,
			selectedTrackId: null,
			selectedTrackIdArray: [],
			selectedTrackList: null,
			selectedVideoType: null,
			selectedTimezone: null,
			selectedPersonArray: [],
			selectedCreateFromPlatform: false,
			selectedZoomLink: true,
			selectedZoomWeb: true,
			selectedGroupChat: false,
			selectedGroupChatId: null,
			selectedNoChatPresentation: false,
			selectedUsingIframe: false,
			showInChatLobby: true,
			selectedTopic: null,
			selectedSession: null,
			keyword: null,
			person: null,
			personArray: [],
			videoUrl: null,
			videoUpload: null,
			videoIframe: null,
			isShowStartDate: false,
			isShowStartTime: false,
			isShowEndDate: false,
			isShowEndTime: false,
			isLoading: null,
			startDate: null,
			endDate: null,
			startTime: null,
			endTime: null,
			attachment: null,
			attachment1: null,
			attachment2: null,
			attachment3: null,
			attachment4: null,
			attachment5: null,
			baseLocation: axios.defaults.baseURL,
			dialogAddPresentation: false,
			dialogEditPresentation: false,
			dialogDeletePresentation: false,
			dialogAddSchedule: false,
			dialogEditSchedule: false,
			dialogDeleteSchedule: false,
			dialogAddZoomMeeting: false,
			ticketList: [],
			today: new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate(),
			hour: "00",
			minute: "00",
			search: "",
			searchPresentationList:[],
			date: new Date().toISOString().substr(0, 10),
			searchDate: null,
			searchDateMenu: false,
			indexTargetDrag: null,
			activeDrag: true,
			marginTop:0,
			zoomSettings: null,
			itemEmbedHtmlBeside: ['None','Left','Right'],
			tabEmbedHtmlBeside: 0,
			trainingCategoryList:[],
		};
	},
	mounted() {
		this.setTrainingCategory();
		this.listPresentation();
		this.listTrack();
		this.listTicket();
		this.listSession();
		this.getZoomSettings();
	},
	methods: {
		listPresentation() {
			axios
				.post("/system/presentation/list", {
					experienceId: this.experienceId,
				})
				.then((response) => {
					this.presentationList = response.data;
					for (let presentation of this.presentationList) {
						if (presentation.type === 'Zoom Webinar' || presentation.type === 'Zoom Meeting') {
							if (presentation.dataMap.disablePreview == null) {
								presentation.dataMap.disablePreview = true;
							}
						}
					}
					this.searchPresentationList = this.$root.clone(this.presentationList);
				})
				.catch(() => {});
		},
		listTrack() {
			axios
				.post("/system/track/list", {
					experienceId: this.experienceId,
				})
				.then((response) => {
					this.trackList = response.data;
				})
				.catch(() => {});
		},
		listSession() {
			axios
				.post("/system/presentationschedule/session/list", {
					experienceId: this.experienceId,
				})
				.then((response) => {
					this.sessionList = response.data;
				})
				.catch(() => {});
		},
		trackListToTrackIdArray() {
			this.selectedTrackIdArray = [];
			for (let track of this.selectedTrackList) {
				this.selectedTrackIdArray.push(track.id);
			}
		},
		pushTrackId(id) {
			if (id != null) {
				if (this.selectedTrackIdArray.indexOf(id) === -1) {
					this.selectedTrackIdArray.push(id);
				}
			}
		},
		removeTrackId(id) {
			this.selectedTrackIdArray = this.selectedTrackIdArray.filter(function (item) {
				return item != id;
			});
		},
		formatDate(date) {
			if (date != null) {
				var year = parseInt(date.substring(0, 4));
				var month = parseInt(date.substring(5, 7));
				var day = parseInt(date.substring(8, 10));
				const monthNames = [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December",
				];
				var time = date.split(" ")[1].substring(0, 5);
				return day + " " + monthNames[month - 1] + " " + year + " " + time;
			} else {
				return "";
			}
		},
		handleFileUpload(fileList) {
			this.attachment = fileList[0];
		},
		handleFile1Upload(fileList) {
			this.attachment1 = fileList[0];
		},
		handleFile2Upload(fileList) {
			this.attachment2 = fileList[0];
		},
		handleFile3Upload(fileList) {
			this.attachment3 = fileList[0];
		},
		handleFile4Upload(fileList) {
			this.attachment4 = fileList[0];
		},
		handleFile5Upload(fileList) {
			this.attachment5 = fileList[0];
		},
		savePresentation() {
			this.entity.status = this.selectedStatus;
			this.entity.language = this.selectedLanguage;
			this.entity.type = this.selectedType;
			this.entity.zoomLink = this.selectedZoomLink;
			this.entity.zoomWeb = this.selectedZoomWeb;
			this.entity.videoUrl = this.videoUrl;
			this.entity.videoIframe = this.videoIframe;
			this.entity.groupChatId = this.selectedGroupChatId;
			this.entity.isOwnGroup = !this.selectedGroupChat;
			this.entity.dataMap = {
				fileName: this.videoUpload,
				noChatPresentation: this.selectedNoChatPresentation,
				chatOnLobby:
					this.selectedNoChatPresentation || (!this.selectedNoChatPresentation && this.selectedGroupChat) ? false : this.showInChatLobby,
				heightEmbedHtmlBeside: this.entity.dataMap.heightEmbedHtmlBeside,
				heightEmbedHtmlBelow: this.entity.dataMap.heightEmbedHtmlBelow,
				embedCodeUsingIframe: this.selectedUsingIframe,
				disablePreview : this.entity.dataMap.disablePreview,
				trainingCategories : this.entity.dataMap.trainingCategories
			};

			let formData = new FormData();
			formData.append("experienceId", this.experienceId);
			formData.append("entity", JSON.stringify(this.entity));
			if (this.selectedNoChatPresentation || (!this.selectedNoChatPresentation && this.selectedGroupChat)) {
				this.showInChatLobby = false;
			}
			formData.append("chatOnLobby", this.showInChatLobby); // show / hide presentation chat group from chat lobby
			if (this.attachment) {
				formData.append("attachment", this.attachment);
			}

			axios
				.post("/system/presentation/add", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(() => {
					this.listPresentation();
					this.dialogAddPresentation = false;
				})
				.catch(() => {});
		},
		editPresentation(id) {
			this.entity.id = id;
			this.entity.status = this.selectedStatus;
			this.entity.language = this.selectedLanguage;
			this.entity.type = this.selectedType;
			this.entity.zoomLink = this.selectedZoomLink;
			this.entity.zoomWeb = this.selectedZoomWeb;
			this.entity.videoUrl = this.videoUrl;
			this.entity.videoIframe = this.videoIframe;
			this.entity.presenterList = this.selectedPersonArray;
			this.entity.groupChatId = this.selectedGroupChatId;
			this.entity.isOwnGroup = !this.selectedGroupChat;
			this.entity.handoutList = this.handoutList;
			this.entity.dataMap = {
				fileName: this.videoUpload,
				noChatPresentation: this.selectedNoChatPresentation,
				chatOnLobby:
					this.selectedNoChatPresentation || (!this.selectedNoChatPresentation && this.selectedGroupChat) ? false : this.showInChatLobby,
				heightEmbedHtmlBeside: this.entity.dataMap.heightEmbedHtmlBeside,
				heightEmbedHtmlBelow: this.entity.dataMap.heightEmbedHtmlBelow,
				embedCodeUsingIframe: this.selectedUsingIframe,
				ChatRoomToken: this.entity.dataMap.ChatRoomToken,
				disablePreview : this.entity.dataMap.disablePreview,
				trainingCategories : this.entity.dataMap.trainingCategories
			};

			let formData = new FormData();
			formData.append("experienceId", this.experienceId);
			formData.append("entity", JSON.stringify(this.entity));
			if (this.selectedNoChatPresentation || (!this.selectedNoChatPresentation && this.selectedGroupChat)) {
				this.showInChatLobby = false;
			}
			formData.append("chatOnLobby", this.showInChatLobby); // show / hide presentation chat group from chat lobby
			if (this.attachment) {
				formData.append("attachment", this.attachment);
			}
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
			}
			if (this.attachment3) {
				formData.append("attachment3", this.attachment3);
			}
			if (this.attachment4) {
				formData.append("attachment4", this.attachment4);
			}
			if (this.attachment5) {
				formData.append("attachment5", this.attachment5);
			}

			axios
				.post("/system/presentation/edit", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(() => {
					this.listPresentation();
					this.dialogEditPresentation = false;
				})
				.catch(() => {});
		},
		deletePresentation(id) {
			axios
				.post("/system/presentation/delete", {
					id: id,
				})
				.then(() => {
					this.listPresentation();
				})
				.catch(() => {});
		},
		clear() {
			this.entity = {
				title: null,
				description: null,
				status: null,
				language: null,
				keyword: null,
				type: null,
				videoUrl: null,
				videoIframe: null,
				participantUrl: null,
				presentationUrl: null,
				embedCode: null,
				dataMap: {disablePreview: true},
				embedHtmlBesideMap:{ status: "None", value: "" },
                toOnDemand: null,
			};

				(this.selectedStatus = true);
			this.selectedLanguage = null;
			this.selectedType = null;
			this.selectedSession = null;
			this.selectedTimezone = null;
			this.videoUrl = null;
			this.videoUpload = null;
			this.selectedPresentationId = null;
			this.selectedPresentationType = null;
			this.startDate = null;
			this.endDate = null;
			this.startTime = null;
			this.endTime = null;
			this.selectedTrackIdArray = [];
			this.attachment1 = null;
			this.attachment2 = null;
			this.attachment3 = null;
			this.attachment4 = null;
			this.attachment5 = null;
		},
		savePresentationSchedule() {
			this.entity.presentationId = this.selectedPresentationId;
			this.entity.timezone = this.selectedTimezone;
			this.entity.session = this.selectedSession;

			if (this.entity.session == '') {
				this.entity.session = null;
			}

			const zeroPad = (num, places) => String(num).padStart(places, '0')
			var hour = zeroPad(parseInt(this.startDate.substring(11, 13)) , 2);
			var minute = zeroPad(parseInt(this.startDate.substring(14, 16)), 2);
			this.startTime = hour + ":" + minute;
			if (this.startDate) {
				if (this.startTime) {
					this.entity.dataMap.startDate = this.startDate;
					this.entity.dataMap.startTime = this.startTime;
				} else {
					this.entity.dataMap.startDate = this.startDate + " " + "00:00";
				}
			}
			if (this.startTime) {
				this.entity.dataMap.startTime = this.startTime;
			}

			hour = zeroPad(parseInt(this.endDate.substring(11, 13)) , 2);
			minute = zeroPad(parseInt(this.endDate.substring(14, 16)), 2);
			this.endTime = hour + ":" + minute;
			if (this.endDate) {
				if (this.endTime) {
					this.entity.dataMap.endDate = this.endDate;
					this.entity.dataMap.endTime = this.endTime;
				} else {
					this.entity.dataMap.endDate = this.endDate + " " + "00:00";
				}
			}
			if (this.endTime) {
				this.entity.dataMap.endTime = this.endTime;
			}

			axios
				.post("/system/presentationschedule/add", {
					entity: this.entity,
					track: this.selectedTrackIdArray,
				})
				.then(() => {
					this.listPresentation();
					this.dialogAddSchedule = false;
				})
				.catch(() => {});
		},
		editPresentationSchedule(id) {
			this.entity.id = id;
			this.entity.presentationId = this.selectedPresentationId;
			this.entity.timezone = this.selectedTimezone;
			this.entity.session = this.selectedSession;

			if (this.entity.session == '') {
				this.entity.session = null;
			}

			const zeroPad = (num, places) => String(num).padStart(places, '0')
			var hour = zeroPad(parseInt(this.startDate.substring(11, 13)) , 2);
			var minute = zeroPad(parseInt(this.startDate.substring(14, 16)), 2);
			this.startTime = hour + ":" + minute;
			if (this.startDate) {
				if (this.startTime) {
					this.entity.dataMap.startDate = this.startDate;
					this.entity.dataMap.startTime = this.startTime;
				} else {
					this.entity.dataMap.startDate = this.startDate + " " + "00:00";
				}
			}
			if (this.startTime) {
				this.entity.dataMap.startTime = this.startTime;
			}

			hour = zeroPad(parseInt(this.endDate.substring(11, 13)) , 2);
			minute = zeroPad(parseInt(this.endDate.substring(14, 16)), 2);
			this.endTime = hour + ":" + minute;
			if (this.endDate) {
				if (this.endTime) {
					this.entity.dataMap.endDate = this.endDate;
					this.entity.dataMap.endTime = this.endTime;
				} else {
					this.entity.dataMap.endDate = this.endDate + " " + "00:00";
				}
			}
			if (this.endTime) {
				this.entity.dataMap.endTime = this.endTime;
			}

			axios
				.post("/system/presentationschedule/edit", {
					entity: this.entity,
					track: this.selectedTrackIdArray,
				})
				.then(() => {
					this.listPresentation();
					this.dialogEditSchedule = false;
				})
				.catch(() => {});
		},
		deletePresentationSchedule(id) {
			axios
				.post("/system/presentationschedule/delete", {
					id: id,
				})
				.then(() => {
					this.listPresentation();
				})
				.catch(() => {});
		},
		createTeamsMeeting(presentationId) {
			axios
				.post("/system/presentation/teams/create", {
					experienceId: this.experienceId,
					presentationId: presentationId
				})
				.then(() => {
					this.listPresentation();
				})
				.catch(() => {});
		},
		deleteTeamsMeeting(presentationId) {
			axios
				.post("/system/presentation/teams/delete", {
					experienceId: this.experienceId,
					presentationId: presentationId
				})
				.then(() => {
					this.listPresentation();
				})
				.catch(() => {});
		},
		showAddZoomMeeting(item, type) {
			this.dialogAddZoomMeeting = true;
			this.selectedPresentationScheduleId = item.id;
			this.selectedPresentationType = type;
			this.selectedTimezone = item.timezone;
			this.listTimezone();
			this.setPosition();
		},
		createZoomMeeting() {
			this.entityZoomMeeting.timezone = this.selectedTimezone;
				axios
				.post("/system/zoom/oauth/meeting/add", {
					entity: this.entityZoomMeeting,
					id: this.selectedPresentationScheduleId
				})
				.then(() => {
					this.clearZoomGenerateForm();
					this.listPresentation();
				})
				.catch(() => {});
		},
		createZoomWebinar() {
			this.entityZoomMeeting.timezone = this.selectedTimezone;
				axios
				.post("/system/zoom/oauth/webinar/add", {
					entity: this.entityZoomMeeting,
					id: this.selectedPresentationScheduleId
				})
				.then(() => {
					this.clearZoomGenerateForm();
					this.listPresentation();
				})
				.catch(() => {});
		},
		clearZoomGenerateForm(){
			this.entityZoomMeeting = {
				topic: null,
				timezone: null,
				password: null,
				agenda: null,
			}
		},
		deleteZoomLink(id) {
			if (confirm("Are you sure you want to delete this generated link?")){
				axios
				.post("/system/zoom/oauth/presentation/link/delete", {
					id: id
				})
				.then(() => {
					this.listPresentation();
				})
				.catch(() => {});
			}
		},
		listPresenter() {
			axios
				.post("/system/presentation/presenter/list", {
					experienceId: this.experienceId,
					presentationId: this.selectedPresentationId,
				})
				.then((response) => {
					this.selectedPersonArray = response.data;
				})
				.catch(() => {});
		},
		addPresenter(keyword) {
			var emailArray = keyword.split("\n");
			axios
				.post("/system/presentation/person/list", {
					experienceId: this.experienceId,
					email: emailArray,
				})
				.then((response) => {
					this.personList = response.data;

					if (this.personList != null) {
						for (let person of this.personList) {
							if (person != null) {
								var isSame = false;
								for (let item of this.selectedPersonArray) {
									if (item.id == person.id) {
										isSame = true;
									}
								}

								if (isSame == false) {
									person.dataMap.topic = this.selectedTopic;
									this.selectedPersonArray.push(person);
								}

								if (isSame == true) {
									person.dataMap.topic = this.selectedTopic;
									this.removePresenter(person.id);
									this.selectedPersonArray.push(person);
								}
							}
						}
					}
				})
				.catch(() => {});
		},
		removePresenter(id) {
			this.selectedPersonArray = this.selectedPersonArray.filter(function (item) {
				return item.id != id;
			});
		},
		removeHandout(id) {
			this.handoutList = this.handoutList.filter(function (item) {
				return item.id != id;
			});
		},
		listTimezone() {
			axios
				.get("/system/enumeration/timezone/list")
				.then((response) => {
					this.timezoneList = response.data;
				})
				.catch(() => {});
		},
		listPublicChatRoom() {
			axios.get("/system/generalPublicChatRoom/list?experienceId=" + this.experienceId).then((response) => {
				if (response.data) {
					this.publicChatRoomList = response.data;
				}
			});
		},
		listTicket() {
			axios
				.get("/system/ticket/list?experienceId=" + this.experienceId)
				.then((response) => {
					this.ticketList = response.data;
				})
				.catch(() => {});
		},
		showEditPresentation(item) {
			axios
				.get("/system/presentation?id=" + item.id)
				.then((response) => {
					this.entity.allowTicketList = response.data.allowTicketList;
					this.entity.denyTicketList = response.data.denyTicketList;
                    this.entity.toOnDemand = response.data.toOnDemand;

					if (!this.entity.embedHtmlBesideMap.tabs) {
						this.entity.embedHtmlBesideMap.tabs = [{name: 'Tab 1', value: this.entity.embedHtmlBesideMap.value}];
					}
					if (!this.entity.embedHtmlBesideMap.resourcesTabPosition) {
						this.entity.embedHtmlBesideMap.resourcesTabPosition = 1;
					}
					this.dialogEditPresentation = true;
				})
				.catch(() => {});
		},
		resetTime() {
			this.hour = "00";
			this.minute = "00";
			this.second = "00";
		},
		changeDatetime(dateTime) {
			if (dateTime === "") {
				return this.today + " " + this.hour + ":" + this.minute;
			} else {
				return dateTime.substr(0, 10) + " " + this.hour + ":" + this.minute;
			}
		},
		searchPresentation(){
			this.searchPresentationList = [];
			if ((this.search !== '' && this.search != null) || (this.searchDate !== '' && this.searchDate != null)) {
				axios
					.post("/system/presentation/id/list",{
						experienceId: this.experienceId,
						title: this.search == null ? "" : this.search,
						datetime: this.searchDate == null ? "" : moment(this.searchDate).format('YYYY-MM-DD')
					})
					.then((response) => {
						for (let presentation of this.presentationList) {
							if (response.data.includes(presentation.id)) {
								this.searchPresentationList.push(presentation);
							}
						}
						this.activeDrag = false;
					})
					.catch(() => {});
			} else {
				this.searchPresentationList = this.$root.clone(this.presentationList);
				this.activeDrag = true;
			}
		},
		allowDrop(ev) {
			ev.preventDefault();
		},
		drag(index) {
			this.indexTargetDrag = index;
		},
		drop(index) {
			var tmp = this.searchPresentationList.splice(this.indexTargetDrag, 1) ;
			this.searchPresentationList.splice(index, 0, tmp[0]);
			this.updateSortOrder();
		},
		updateSortOrder() {
			var editDataList = []
			for (let i = 0; i < this.presentationList.length; i++) {
				editDataList.push({
					"id": this.searchPresentationList[i].id,
					"sortOrder" : this.presentationList[i].sortOrder
				})
			}

			axios
				.post("/system/presentation/edit/sortOrder",{
					editDataList: editDataList
				})
				.then((response) => {
					if (response.data) {
						this.listPresentation();
					}
				})
				.catch(() => {});
		},
		setPosition() {
			var rect = this.$refs.canvas.getBoundingClientRect();
			let top = rect.top;
			if (top >= 0) {
				this.marginTop = 0;
			} else {
				this.marginTop = top - top - top;
			}
		},
		getZoomSettings() {
			axios.get("/system/zoomsettings/get").then((response) => {
				this.zoomSettings = response.data;
			});
		},
		newTab() {
			this.entity.embedHtmlBesideMap.tabs.push({name: "Tab " + (parseInt(this.entity.embedHtmlBesideMap.tabs.length) + 1), value: ""});
			this.tabEmbedHtmlBeside = this.entity.embedHtmlBesideMap.tabs.length - 1;
		},
		removeTab(index) {
			this.entity.embedHtmlBesideMap.tabs.splice(index, 1);
		},
		setTrainingCategory() {
			axios.get("/system/vTraining/category/list").then((response) => {
				if (response.data) {
					this.trainingCategoryList = response.data;
				}
			});
		}
	},
	watch: {
		date () {
			if (!this.date) return null
			this.searchDate = moment(this.date).format('DD MMMM YYYY');
		},
	},
};
</script>
